import React from 'react';

import Button from '../../01_atoms/Button';
import Spinner from '../../01_atoms/Spinner';

import { PTButtonField, PTButtonFieldDefaults } from './prop-types';
import { formatAmount } from '../../../utils/currency';
import RightThinChevron from '../../../public/static/icons/navigation-chevron-right-white.svg';

// TODO: use CSS modules.
class ButtonField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isHovering: false,
      isLoading: false,
    };
  }

  onSubmit = (event) => {
    // Make sure that tabbing through the link doesn't fire the onClick.
    if (event.keyCode === 9) {
      return null;
    }

    const { value, currency, isDisabled, onSubmit, disableLoadingFeature, position } = this.props;

    if (isDisabled) {
      return null;
    }

    // TODO: consider reworking in an simpler solution.
    // setState in callback generates warning in real world application:
    // Can't perform a React state update on an unmounted component.
    if (disableLoadingFeature) {
      return onSubmit({ value, currency, position });
    }

    this.setState((state) => ({ ...state, isLoading: true }));
    return onSubmit({ value, currency, position }).then(() => {
      this.setState((state) => ({ ...state, isLoading: false }));
    });
  };

  render() {
    const {
      value,
      buttonLabel,
      currency,
      description,
      fadeClass,
      isDisabled,
      changeFontSizeWithDesc,
      buttonClassName,
      descriptionTitle,
    } = this.props;
    const { isHovering, isLoading } = this.state;

    const formattedValue = formatAmount(currency, value);

    return (
      <div
        className={`d-md-flex flex-column align-items-start button-field ${
          isDisabled ? 'disabled' : ''
        } ${fadeClass} ${isLoading ? 'loading' : ''}`}
        onMouseEnter={() => !isDisabled && !isLoading && this.setState({ isHovering: true })}
        onMouseLeave={() => this.setState({ isHovering: false })}
        onClick={this.onSubmit}
        onKeyDown={this.onSubmit}
      >
        {description || descriptionTitle ? (
          <>
            <div className={`${changeFontSizeWithDesc ? 'd-md-none ' : ''}header-one`}>
              {formattedValue}
            </div>
            {changeFontSizeWithDesc && (
              <div className="d-none d-md-block header-two rockitt">{formattedValue}</div>
            )}
            {descriptionTitle && <div className="description-title">{descriptionTitle}</div>}
            <p>{description}</p>
          </>
        ) : (
          <>
            <div className="header-one">{formattedValue}</div>
            <p>&nbsp;</p>
          </>
        )}

        <Button
          className={`mt-auto d-none d-md-block ${buttonClassName}`}
          type="white-pink"
          isBlock
          isOutlined={!isHovering || isLoading}
          isLoading={isLoading}
          isDisabled={isDisabled}
        >
          {buttonLabel}
          <span className="amount-info">&nbsp;{formattedValue}</span>
        </Button>

        <RightThinChevron
          className={`d-md-none chevron ${isLoading ? 'd-none' : ''} ${isHovering ? 'hover' : ''}`}
        />

        <Spinner className={`d-md-none ${!isLoading ? 'd-none' : ''}`} />
      </div>
    );
  }
}

ButtonField.propTypes = {
  ...PTButtonField,
  currency: PTButtonField.currency.isRequired,
};
ButtonField.defaultProps = PTButtonFieldDefaults;

export default ButtonField;
